import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {saleCallSourceActions} from "./saleCallSourceSlice";
import {saleApi} from "~/api";

function* fetchSaleCallSourceList(action) {
	try {
		const response = yield call(saleApi.callSourceGets, action.payload);
		yield put(saleCallSourceActions.fetchDataSuccess(response));
	}
	catch (error) {
		console.log('Failed to fetch saleCallSource list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(saleCallSourceActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(saleCallSourceActions.setFilter(action.payload));
}

export default function* saleCallSourceSaga() {
	yield takeLatest(saleCallSourceActions.fetchData.type, fetchSaleCallSourceList);
	yield debounce(500, saleCallSourceActions.setFilterWithDebounce.type, handleSearchDebounce);
}

